@if (loading) {
  <div>
    <div class="fui-layout-container">
      <div class="fui-layout-pad-content">
        <myp-skeleton-loader type="line" width="36%" extraContainerClass="m-t-100 m-b-50" height="30px"></myp-skeleton-loader>
        <myp-skeleton-loader type="line" width="98%" extraContainerClass="m-b-10" height="10px"></myp-skeleton-loader>
        <myp-skeleton-loader type="line" width="100%" extraContainerClass="m-b-10" height="10px"></myp-skeleton-loader>
        <myp-skeleton-loader type="line" width="40%" extraContainerClass="m-b-50" height="10px"></myp-skeleton-loader>
      </div>
      <hr />
      <div class="fui-layout-pad-content m-t-50">
        <div class="grid-container even-rows pad-10">
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
          <myp-skeleton-loader type="learn-video"></myp-skeleton-loader>
        </div>
      </div>
    </div>
  </div>
}

@if (lesson) {
  <div class="fui-layout-container learn-content-details">
    <fui-layout-header [breadcrumbs]="breadcrumbs" [headingText]="lesson.title" [description]="lesson.description"></fui-layout-header>
    <hr />
    <div class="fui-layout-pad-content">
      <div class="m-y-30 d-flex align-items-center justify-content-between flex-wrap">
        <div class="d-flex align-items-center">
          <div class="m-r-20 m-y-10">
            <fa-icon icon="video"></fa-icon>
            {{ lesson.videos.length }} Videos
          </div>
          <div class="m-r-20 m-y-10">
            <fa-icon icon="clock"></fa-icon>
            {{ helperService.hhmmss(lesson.runtime, true) }}
          </div>
        </div>
        <button class="fui-action-btn sm m-r-10" (click)="toggleSaveLesson(lesson)">
          <fa-icon [animation]="loadingSaveLesson ? 'spin' : undefined" [icon]="loadingSaveLesson ? 'spinner' : contentService.userLearnData.lessons[lesson.id]?.enrolled ? 'minus' : 'plus'"></fa-icon>
          {{ contentService.userLearnData.lessons[lesson.id]?.enrolled ? "Remove from My Library" : "Add to My Library" }}
        </button>
      </div>
    </div>
    <hr />
    <div class="fui-layout-pad-content m-y-50">
      @if (!lesson.subscription_only || user.active_subscription) {
        <div class="learn-content-percentage m-b-50">
          <div class="slider" [style]="'width: ' + lesson.progress + '%;'"></div>
          <span class="percentage-done">My Progress: {{ lesson.progress }}% Complete</span>
        </div>
      }
      <fui-heading [text]="'Videos In This Lesson'" [level]="2" fontSize="f7"></fui-heading>
      <div class="grid-container wider pad-10">
        @for (video of lesson.videos; track video; let i = $index) {
          <myp-video-grid-item [lessonID]="lesson.id" [showDate]="false" [numbered]="i + 1" [video]="video"></myp-video-grid-item>
        }
      </div>
    </div>
    <div class="p-y-50">
      <fui-footer></fui-footer>
    </div>
  </div>
}
